import * as React from 'react';
import { useAccountDocumentsArDocDocDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountsDocumentsArDocDocDate = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountDocumentsArDocDocDate();
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
